import { useEffect, useState } from 'react';
import { allocateUser, listUsers, type User } from '../api';

export default function Users() {
  const [users, setUsers] = useState<User[]>([]);
  const [q, setQ] = useState('');
  const [prefix, setPrefix] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function load() {
    try {
      setErr(null);
      const r = await listUsers(q || undefined);
      setUsers(r.users);
    } catch (e) {
      setErr(String(e));
    }
  }

  useEffect(() => {
    void load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function onAllocate(e: React.FormEvent) {
    e.preventDefault();
    if (!prefix.trim()) return;
    setBusy(true);
    setErr(null);
    try {
      const u = await allocateUser(prefix.trim());
      await load();
      alert(`払い出し: ${u.name}`);
    } catch (e) {
      setErr(String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <h2>テストユーザー</h2>

      <div className="card">
        <h3>プリフィックスから連番払い出し</h3>
        <form onSubmit={onAllocate} className="row">
          <input
            placeholder="プリフィックス（例: aihara）"
            value={prefix}
            onChange={(e) => setPrefix(e.target.value)}
            style={{ minWidth: 240 }}
          />
          <button disabled={busy || !prefix.trim()}>払い出す</button>
        </form>
        <p className="muted" style={{ marginTop: 8 }}>
          `aihara` を投げると `aihara88` の次は `aihara89` が返る。
        </p>
      </div>

      <div className="card">
        <h3>一覧・検索</h3>
        <form
          className="row"
          onSubmit={(e) => {
            e.preventDefault();
            void load();
          }}
        >
          <input
            placeholder="名前で前方一致検索（例: aiha）"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            style={{ minWidth: 240 }}
          />
          <button className="ghost small">検索</button>
          <button
            type="button"
            className="ghost small"
            onClick={() => {
              setQ('');
              setTimeout(() => void load(), 0);
            }}
          >
            クリア
          </button>
        </form>
        {err && <div className="error">{err}</div>}
        <table style={{ marginTop: 12 }}>
          <thead>
            <tr>
              <th>名前</th>
              <th>プリフィックス</th>
              <th>連番</th>
              <th>作成日時</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.name}>
                <td>
                  <strong>{u.name}</strong>
                </td>
                <td>{u.prefix}</td>
                <td>{u.seq}</td>
                <td className="muted">{u.createdAt}</td>
              </tr>
            ))}
            {users.length === 0 && (
              <tr>
                <td colSpan={4} className="muted">
                  該当なし
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
